var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.toolTip)?_c('img',{attrs:{"src":require("../../assets/question-icon.svg"),"alt":""},on:{"click":_vm.openPopup}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }